<template>
  <div class="full-height" style="background: #efefef;">
    <Header></Header>
    <div class="flex mL15 mt15 mr15 mb15" style="height: calc(100% - 90px);">
      <div style="padding: 40px;" class="mr10 rad10 bg-f">
        <div class="flex">
          <div style="flex: 2" class="pt20">
            <div class="fl width-200 mr50 mb50">
              <div class="fl imgBg"><img src="../../static/images/money.png" /></div>
              <span class="fb mL10">退休时存款</span><br />
              <span class="f28 mL10 mt5 inline-block">1,000,000</span>
            </div>
            <div class="fl width-200 mb50">
              <div class="fl imgBg"><img src="../../static/images/person.png" style="margin: 10px;" /></div>
              <span class="fb mL10">退休年龄</span><br />
              <span class="f28 mL10 mt5 inline-block">65</span>
            </div>
            <div class="fl width-200 mr50">
              <div class="fl imgBg"><img src="../../static/images/yield.png" style="width: 35px;margin: 13px;" /></div>
              <span class="fb mL10">年化收益率</span><br />
              <span class="f28 mL10 mt5 inline-block">6.55%</span>
            </div>
            <div class="fl width-200">
              <div class="fl imgBg"><img src="../../static/images/save.png" /></div>
              <span class="fb mL10">储蓄比例</span><br />
              <span class="f28 mL10 mt5 inline-block">6.55%</span>
            </div>
          </div>
          <div id="imgChart" style="height: 220px;flex: 1;"></div>
        </div>
        <div class="leftMiddle">
          <p class="f20 fb">财富积累概览</p>
          <div id="wealthAccumulation" style="height: 270px;"></div>
        </div>
        <div class="mt10">
          <p class="f20 fb">资产配置概览</p>
          <div id="assetAllocation" style="height: 270px;"></div>
        </div>
      </div>
      <div style="" class="rad10">
        <div class="wealth rad10 bg-f mb10">
          <p class="f20 mb10 fb">财富规划设置</p>
          <div class="block" v-for="(item, key) in wealthList" :key="key">
            <span class="demonstration fb">{{item.name}}</span>
            <el-slider v-model="item.value" @change="sliderChange(item)"></el-slider>
          </div>
        </div>
        <div class="pension rad10 bg-f mb10">
          <p class="f20 mb15 fb">社保养老金设置</p>
          <div class="mb10 selectDiv">
            <span class="fb inline-block width-90">城市</span>
            <el-select v-model="city" placeholder="请选择" class="width-200">
              <el-option v-for="item in citys" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <div class="mb10">
            <span class="fb inline-block width-90">性别</span>
            <el-button class="base-bg co-f">男</el-button>
            <el-button style="margin-left: 0;">女</el-button>
          </div>
          <div class="mb10 inputDiv">
            <span class="fb inline-block width-90">专项扣除</span>
            <el-input v-model="specialDeductions" class="rad20 inline-block width-200" placeholder="请输入专项扣除"></el-input>
          </div>
          <div class="mb10 numberYear">
            <span class="fb inline-block width-90">实际缴费年限</span>
            <el-input-number v-model="year" :min="1" :max="10"></el-input-number>
          </div>
          <div class="mb15 inputDiv">
            <span class="fb inline-block width-90">当前余额</span>
            <el-input v-model="balance" class="rad20 width-200" placeholder="请输入当前余额"></el-input>
          </div>
          <p class="f20 mb15 fb">企/职业年金设置</p>
          <div class="mb10 inputDiv">
            <span class="fb inline-block width-90">当前余额</span>
            <el-input v-model="balance" class="rad20 width-200" placeholder="请输入当前余额"></el-input>
          </div>
          <div class="mb15 selectDiv">
            <span class="fb inline-block width-90 fl mr5" style="margin-top: 3px;">缴费比例</span>
            <el-slider v-model="annuityontribution" class="width-100 inline-block fl mt5"></el-slider>
            <el-select v-model="annuityontributionSelect" placeholder="偏债型" class="mL10 width-90">
              <el-option v-for="item in annuityontributionSelects" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <p class="f20 mb10 fb">个人年金设置</p>
          <div class="mb10 selectDiv" style="height: 70px;">
            <span class="fb inline-block width-90 fl mr5">商业养老<br />(税优)<br />每月缴费</span>
            <el-slider v-model="annuityontribution" class="width-100 inline-block fl mt20"></el-slider>
            <el-select v-model="annuityontributionSelect" placeholder="偏债型" class="mL10 mt15 width-90">
              <el-option v-for="item in annuityontributionSelects" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <div class="mb10 selectDiv" style="height: 70px;">
            <span class="fb inline-block width-90 fl mr5">商业养老<br />(非税优)<br />投资额度</span>
            <el-slider v-model="annuityontribution" class="width-100 inline-block fl mt20"></el-slider>
            <el-select v-model="annuityontributionSelect" placeholder="偏债型" class="mL10 mt15 width-90">
              <el-option v-for="item in annuityontributionSelects" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <div class="btns">
          <el-button class="base-bg co-f">养老策略规划</el-button>
          <el-button class="base-bg co-f">产品策略匹配</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
export default{
   data () {
      return {
         annuityontribution: 20,
         annuityontributionSelect: '',
         annuityontributionSelects: [],
         balance: '',
         year: 1,
         specialDeductions: '',
         citys: ['北京','上海'],
         city: '北京',
         value2: 20,
         wealthList: [
            {name: '月储蓄比例', value: 20},
            {name: '活期存款比例', value: 40},
            {name: '债券型资产比例', value: 60},
            {name: '偏股型资产比例', value: 30},
            {name: '退休年龄', value: 35},
         ],
         option: {},
         myChartData: [],
         getToken: ''
      }
   },
  components: { Header },
  computed: {
    token () {
      return this.$store.getters.getToken
    }
  },
  mounted () {
    this.getToken = this.token === '' ? localStorage.getItem('token') : this.token
    const url = this.$api.AllInfo
    this.$http.get(url, {}, {Authorization: `Bearer ${this.getToken}`}, '', res => {

    })
    this.myChartData = [
      {
        value: [4200, 3000, 20000, 35000, 50000],
        name: '收益属性'
      },
      {
        value: [5000, 14000, 28000, 26000, 42000],
        name: '现金流属性'
      },
      {
        value: [6000, 10000, 20000, 23000, 40000],
        name: '安全属性'
      }
    ]
    let myChart = this.$echarts.init(document.getElementById('imgChart'))
    myChart.setOption({
      title: {
        text: 'Basic Radar Chart'
      },
      legend: {
        show: false
        // data: ['Allocated Budget', 'Actual Spending']
      },
      radar: {
        // shape: 'circle',
        indicator: [
          { name: '收益属性', max: 6500 },
          { name: '波动属性', max: 16000 },
          { name: '安全属性', max: 30000 },
          { name: '流动属性', max: 38000 },
          { name: '现金流属性', max: 52000 }
        ]
      },
      series: [
        {
          name: 'Budget vs spending',
          type: 'radar',
          data: this.myChartData
        }
      ]
    })
    let wealthChart = this.$echarts.init(document.getElementById('wealthAccumulation'))
    wealthChart.setOption({
      title: {
        text: 'Stacked Line'
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: 'Email',
          type: 'line',
          stack: 'Total',
          data: [120, 132, 101, 134, 90, 230, 210]
        },
        {
          name: 'Union Ads',
          type: 'line',
          stack: 'Total',
          data: [220, 182, 191, 234, 290, 330, 310]
        },
        {
          name: 'Video Ads',
          type: 'line',
          stack: 'Total',
          data: [150, 232, 201, 154, 190, 330, 410]
        },
        {
          name: 'Direct',
          type: 'line',
          stack: 'Total',
          data: [320, 332, 301, 334, 390, 330, 320]
        },
        {
          name: 'Search Engine',
          type: 'line',
          stack: 'Total',
          data: [820, 932, 901, 934, 1290, 1330, 1320]
        }
      ]
    })
    let assetAllocationChart = this.$echarts.init(document.getElementById('assetAllocation'))
    assetAllocationChart.setOption({
      title: {
        text: 'Stacked Area Chart'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        }
      },
      legend: {
        data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: 'Email',
          type: 'line',
          stack: 'Total',
          areaStyle: {},
          emphasis: {
            focus: 'series'
          },
          data: [120, 132, 101, 134, 90, 230, 210]
        },
        {
          name: 'Union Ads',
          type: 'line',
          stack: 'Total',
          areaStyle: {},
          emphasis: {
            focus: 'series'
          },
          data: [220, 182, 191, 234, 290, 330, 310]
        },
        {
          name: 'Video Ads',
          type: 'line',
          stack: 'Total',
          areaStyle: {},
          emphasis: {
            focus: 'series'
          },
          data: [150, 232, 201, 154, 190, 330, 410]
        },
        {
          name: 'Direct',
          type: 'line',
          stack: 'Total',
          areaStyle: {},
          emphasis: {
            focus: 'series'
          },
          data: [320, 332, 301, 334, 390, 330, 320]
        },
        {
          name: 'Search Engine',
          type: 'line',
          stack: 'Total',
          label: {
            show: true,
            position: 'top'
          },
          areaStyle: {},
          emphasis: {
            focus: 'series'
          },
          data: [820, 932, 901, 934, 1290, 1330, 1320]
        }
      ]
    })
    // setTimeout(function (){ window.onresize = function () { myChart.resize(); } },200);
    // setTimeout(function (){ window.onresize = function () { wealthChart.resize(); } },200);
    // setTimeout(function (){ window.onresize = function () { assetAllocationChart.resize(); } },200);
    // window.onresize = function () { myChart.resize(); }
    // window.onresize = function () { wealthChart.resize(); }
    // window.onresize = function () { assetAllocationChart.resize(); }
  },
  methods: {
    sliderChange (item) {
      console.log(item);
      this.myChartData = [
        {
          value: [1200, 2000, 40000, 15000, 30000],
          name: '收益属性'
        },
        {
          value: [6000, 18000, 18000, 20000, 12000],
          name: '现金流属性'
        },
        {
          value: [3000, 15000, 10000, 13000, 10000],
          name: '安全属性'
        }
      ]
      let myChart = this.$echarts.init(document.getElementById('imgChart'))
      myChart.clear()
      myChart.setOption({
        title: {
          text: 'Basic Radar Chart'
        },
        legend: {
          show: false
          // data: ['Allocated Budget', 'Actual Spending']
        },
        radar: {
          // shape: 'circle',
          indicator: [
            { name: '收益属性', max: 6500 },
            { name: '波动属性', max: 16000 },
            { name: '安全属性', max: 30000 },
            { name: '流动属性', max: 38000 },
            { name: '现金流属性', max: 52000 }
          ]
        },
        series: [
          {
            name: 'Budget vs spending',
            type: 'radar',
            data: this.myChartData
          }
        ]
      })
    }
  }
}
</script>

<style>
.selectDiv .el-select .el-input .el-select__caret{
  line-height: 28px;
}
.inputDiv .el-input .el-input__inner{
  border-radius: 23px;
}
.numberYear .el-input .el-input__inner{
  border: transparent;
}
.numberYear .el-input-number .el-input-number__decrease.is-disabled,
.numberYear .el-input-number__increase,
.numberYear .el-input-number__decrease{
  height: 28px;
  line-height: 28px;
  background: #e90a5b;
  color: #fff;
}
.numberYear .el-input-number{
  width: 200px;
}
</style>
<style scoped>
.wealth{
   height: 280px;
   padding: 15px 20px;
}
.pension{
   padding: 15px 20px;
   height: calc(100% - 340px);
}
.pension>>>.el-input--suffix .el-input__inner,
.pension>>>.el-input__inner {
   height: 28px;
}
.pension>>>.el-button{
   height: 28px;
   line-height: 0;
   width: 98px;
}
.pension>>>.el-select>>>.el-input__inner{
   border-radius: 5px;
}
.block >>> .el-slider__runway,
.el-slider >>> .el-slider__runway{
   margin: 7px 0;
}
.btns .el-button{
  width: 160px;
  height: 35px;
  line-height: 0;
}
.imgBg{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #efefef;
}
.imgBg>>>img{
  width: 40px;
  margin: 13px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Result.vue